import { ForsikringProducts } from '../comparison-table-config/product-config';

type DataTrackPrefix = 'comparison-table';

const withDataTrackPrefix = (dataTrackPrefix: DataTrackPrefix, dataTrackDescription: string) =>
    `${dataTrackPrefix}-${dataTrackDescription}`;

export const withComparisonTablePrefix = (dataTrackDescription: string, product?: ForsikringProducts) =>
    withDataTrackPrefix('comparison-table', product ? `${product}-${dataTrackDescription}` : dataTrackDescription);
